module.exports = __webpack_public_path__ + "static/img/yanzheng1.4221fbdb.png";